module.exports = __webpack_public_path__ + "static/media/9d8e7957-f3a9-4d74-80d0-f5a3107577c3.34d2efb4.jpeg";